import { apiCall } from "../helpers/api";

export const job_types = (params = {}) => dispatch => {
    params.path = params.path || "job_types";
    return dispatch(apiCall(params));
}